// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoggerService } from './logger.service';
import { MobileDevice } from '../interfaces/mobile.interface';

// Declare window extensions for mobile bridge
declare global {
  interface Window {
    AndroidApp?: {
      getFcmToken(): string;
      getAndroidId(): string;
    };
    webkit?: {
      messageHandlers?: {
        iosBridge?: {
          postMessage(message: any): void;
        };
      };
    };
  }
}

@Injectable({ providedIn: 'root' })
export class MobileService { 

  public searchTitle: string = ''
  private useMockBridge = false;
  
  
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('mobile');
  }

  constructor(
    private http: HttpClient,
    private loggerService: LoggerService
  ) {}

  register(device: MobileDevice): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/register`, device);
  }


  /**
   * Get mobile device information from the native bridge or mock
   * @returns MobileDevice object or null if bridge is not available
   */
  getDeviceInfo(): MobileDevice | null {
    const deviceId = localStorage.getItem('deviceIdParam');
    const platform = localStorage.getItem('platform');

    if (!deviceId) {
      return null; // No device_id in URL, cannot proceed
    }

    return {
      device_id: deviceId,
      platform: platform,
    };
  }

}